import { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";

import EntityOfficerInvitation from "legal-entities/entities/entity-officer-invitation/entity-officer-invitation";
import EntityOfficerInvitationForm from "legal-entities/entities/entity-officer-invitation/view/components/entity-officer-invitation-form";
import EntityOfficerInvitationsTable from "legal-entities/entities/entity-officer-invitation/view/components/entity-officer-invitations-table";
import EntityOfficerInvitationAPIService from "legal-entities/entities/entity-officer-invitation/api/entity-officer-invitation-api-service";
import { useSession } from "users/session/session-context";
import { CanceledError } from "axios";
import Container from "@mui/material/Container";
import { styled } from "@mui/material";

const StyledEntitiesContainer = styled(Container)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
  },
  padding: theme.spacing(6),
  position: "relative",
  overflowY: "auto", 
  height: "100%"
}));

export default function EntitiesPage() {
  const [openInvitations, setOpenInvitations] = useState<EntityOfficerInvitation[]>([]);
  const session = useSession();

  useEffect(() => {
    let abortController = new AbortController();
    void getOpenInvitations(abortController);
    return () => {
      abortController.abort();
      abortController = new AbortController();
    };
  }, []);

  async function getOpenInvitations(abortController: AbortController) {
    try {
      const service = new EntityOfficerInvitationAPIService(session);
      const returnedInvitations = await service.getAllOpenOfficerInvitations(abortController);
      setOpenInvitations(returnedInvitations);
    } catch (error) {
      if (error instanceof CanceledError) {
        console.log("Request canceled", error.message);
        return;
      }

      console.error(error);
      enqueueSnackbar("Failed to get open invitations", { variant: "error" });
    }
  }

  return (
    <StyledEntitiesContainer>
      <EntityOfficerInvitationForm
        session={session}
        onInvitationCreated={(invitation) => setOpenInvitations([...openInvitations, invitation])}
      />
      <EntityOfficerInvitationsTable
        session={session}
        invitations={openInvitations}
        onInvitationRemoved={(invitation) => setOpenInvitations(openInvitations.filter((i) => i.id !== invitation.id))}
      />
    </StyledEntitiesContainer>
  );
}
